import { useCallback } from 'react';
import { can, canAny } from '@/lib/domain';
import { useAuth } from './useAuth';

/**
 * UI gating only. The server re-checks every permission and scope, so a
 * hidden button is a convenience, never a security boundary.
 */
export function usePermission() {
  const { user } = useAuth();

  const hasAll = useCallback((...keys: string[]) => can(user, ...keys), [user]);
  const hasAny = useCallback((...keys: string[]) => canAny(user, ...keys), [user]);

  return { can: hasAll, canAny: hasAny, permissions: user?.permissions ?? [] };
}
